/*
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 自定义指令入口
 */
const files = require.context('./config', !1, /.+\.js$/);

export default {
  install(Vue) {
    files.keys().forEach(fileName => {
      const directiveConfig = files(fileName);
      const directiveName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '');
      Vue.directive(directiveName, directiveConfig.default || directiveConfig)
    })
  }
}